export default __webpack_public_path__ + "static/media/CrowdfundingEstadoResultado.ec259ab4.svg";